/**
* @Author: zachalam
* @Date:   2017-01-19T17:12:00-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:12:59-08:00
*/

import React, { Component } from 'react';
import Trips from '../components/pages/Trips/Trips';
import { connect } from 'react-redux';
import { refreshProfile } from '../actions/profileActions';
import { cancelTrip } from '../actions/tripActions';

class TripsContainer extends Component {
  componentWillMount() {
    this.props.refresh();
  }

  render() {
    return (
      <Trips {...this.props} />
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    trips: state.profile.trip.data
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh: () => {
      dispatch(refreshProfile());
    },
    cancelTrip: (tripId,tripKey,reason) => {
      //console.log(tripId);
      dispatch(cancelTrip(tripId,tripKey,reason));
    }
  }
}

export default connect(mapStateTopProps,mapDispatchToProps)(TripsContainer);



// WEBPACK FOOTER //
// ./src/containers/TripsContainer.jsx